var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMsgHidden)?_c('MessageWhenHidden',{attrs:{"content":_vm.msgContent,"is_mobile":_vm.isMobile,"subtitle":_vm.msgSubTitle,"title":_vm.msgTitle}}):_vm._e(),_c('LandingTemplate',{attrs:{"landing-page":_vm.landingPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }